import React, { useCallback, useContext } from 'react'
import { SkillBiteEditSlice } from '../../../../../reducers'
import { useSelector } from 'react-redux'
import { useStyles } from './styles'
import { Box } from '@mui/material'
import { EmailRounded } from '@mui/icons-material'
import { TooltipOverflowTitle } from '../../../build/components/session-selector/components/tooltip-overflow-title'
import { EmailNavigationContext } from '../..'

const EmailIcon = () => {
  return (
    <Box sx={{ width: '36px', height: '36px', padding: '6px', borderRadius: '6px', backgroundColor: '#D4672B', mr: 1 }}>
      <EmailRounded htmlColor='#FFFFFF' />
    </Box>
  )
}

const SessionSelector = ({ sessions }) => {
  const classes = useStyles()

  const selectedSession = useSelector(SkillBiteEditSlice.selectors.selectSelectedSession)
  const { changeSelectedSession } = useContext(EmailNavigationContext)

  const handleChangeSelectedSession = useCallback((session) => {
    if (selectedSession?.id === session?.id) return
    changeSelectedSession(session)
  }, [changeSelectedSession, selectedSession])

  return (
    <Box
      className={classes.sessionListContainer}
      data-test='skill-bite-edit-email-sessions-list'
    >
      {sessions.map((session, index) => {
        const isSelected = session.id === selectedSession?.id

        return (
          <Box
            key={index}
            display='flex'
            flexDirection='row'
            alignItems='center'
            data-test='skill-bite-edit-email-session-selector'
            onClick={() => handleChangeSelectedSession(session)}
            sx={{
              width: '100%',
              border: `1px solid ${isSelected ? '#4AA5EF' : '#BCBCBC'}`,
              boxShadow: 'none',
              borderRadius: '10px !important',
              marginBottom: '8px',
              padding: '8px',
              '&:hover': {
                cursor: 'pointer'
              }
            }}
          >
            <EmailIcon />
            <TooltipOverflowTitle
              title={session.name}
              minCharTooltip={30}
              typographySx={{ fontWeight: isSelected ? 600 : 400, flex: 1 }}
            />
          </Box>
        )
      })}
    </Box>
  )
}

export default SessionSelector
